export default {"src":"/_next/static/media/fuel.f99701bd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};